import { usePathname } from 'expo-router';
import { useEffect } from 'react';

import { useAuth } from '@/src/features/auth/use-auth';
import { useProfile } from '@/src/features/profile/use-profile';
import {
  setSentryRoute,
  setSentryUserIdentity,
} from '@/src/lib/sentry';

export function SentryDiagnosticsTracker() {
  const pathname = usePathname();
  const { user } = useAuth();
  const profileQuery = useProfile(user?.uid);
  const profile = profileQuery.data;

  useEffect(() => {
    setSentryRoute(pathname);
  }, [pathname]);

  useEffect(() => {
    if (!user) {
      setSentryUserIdentity(null);
      return;
    }

    setSentryUserIdentity({
      email: user.email,
      fullName: profile?.fullName ?? user.displayName,
      uid: user.uid,
      username: profile?.username ?? null,
    });
  }, [profile?.fullName, profile?.username, user]);

  return null;
}
